export const minutesToBraindate = 10;
export const takeOverMinutesToBraindate = 5;
export const minutesPastBraindate = 15;
